<template>
  <div>
    <b-card body-="pt-4" header-class="border-0">
      <div v-for="appt in innerAppts" class="pb-4">
        <div class="wrapper">
          <div style="display:grid;grid-template-columns: 250px auto">
            <div style="display:flex">
              <b-avatar />
              <div class="ml-3">
                <b>{{ appt.provider.providerName }}</b
                ><br />
              </div>
            </div>
          </div>

          <div style="text-align:right">
            <b>
              {{ appt.startDate | moment("h:mm A") }} -
              {{ appt.endDate | moment("h:mm A") }}
            </b>
            <br />
            <small> {{ (appt.provider.minutes * 60 * 1000) | humanize }}</small>
          </div>
        </div>

        <table class="mt-4 table">
          <tr>
            <th>
              Procedure
            </th>
            <th>
              Duration
            </th>
            <th style="text-align:right">
              Deposit
            </th>
            <th style="text-align:right">Price</th>
          </tr>
          <tr v-for="procedure in appt.procedures">
            <td>{{ procedure.procedureName }}<br /></td>
            <td>
              {{ (procedure.minutes * 60 * 1000) | humanize }}
            </td>
            <td style="text-align:right">
              <EditMoney v-model="procedure.deposit" />
            </td>
            <td style="text-align:right">
              <EditMoney v-model="procedure.price" />
            </td>
          </tr>
        </table>
      </div>

      <div class="startPaymentWrapper">
        <div
          v-for="s in scheduledPaymentActionOptions"
          @click.prevent="actionSelected(s)"
          style="cursor:pointer;text-align:center"
        >
          <div>
            <i
              class="fas fa-check-square ml-1 text-primary"
              style="font-size:25px"
              v-if="s.isSelected"
            ></i>
            <i
              class="far fa-square ml-1 text-primary"
              style="font-size:25px"
              v-if="!s.isSelected"
            ></i>
          </div>

          <div style="font-size:1em" class="pt-2">
            {{ s.price | currency }}
          </div>
          <div class="text-muted pt-2">
            {{ s.text }}
          </div>
        </div>
      </div>
      <b-button
        block
        variant="primary"
        @click.prevent="createAppt()"
        v-if="amount == 0"
      >
        Create Appointment with No Payment
      </b-button>
    </b-card>

    <div v-if="amount > 0">
      <b-card body-class="p-0" header-class="border-0">
        <div class="card-content">
          <b-tabs card>
            <b-tab no-body title="Terminal Payment" lazy>
              <div class="card-content">
                <div class="p-3 card">
                  <PayByTerminal
                    :addAppts="buildAddApptRequest()"
                    :amount="amount"
                    :customer="customer"
                  />
                </div>
              </div>
            </b-tab>
            <b-tab no-body title="Virtual Terminal" lazy>
              <div class="card-content">
                <div class="p-3 card">
                  <pay-by-virtual
                    :addAppts="buildAddApptRequest()"
                    :amount="amount"
                    :customer="customer"
                  />
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import EditMoney from "@/views/Components/EditMoney.vue";
import PayByTerminal from "@/views/Components/Customer/Actions/PayByTerminal.vue";
import PayByVirtual from "@/views/Components/Customer/Actions/PayByVirtual.vue";
export default {
  props: { appts: null, customer: null },
  components: { PayByTerminal, EditMoney, "pay-by-virtual": PayByVirtual },
  computed: {
    selectedTotal() {
      return this.scheduledPaymentActionOptions.find((f) => f.isSelected).price;
    },
    total() {
      if (!this.innerAppts) return { price: 0, deposit: 0 };

      var t = 0;
      var d = 0;
      this.innerAppts.forEach((a) => {
        a.procedures.forEach((p) => {
          t += p.price;
          d += p.deposit;
        });
      });
      return { price: t, deposit: d };
    },
  },
  watch: {
    innerAppts: {
      handler: function(val, oldVal) {
        this.setScheduledPaymentOptions();
        this.actionSelected(this.act);
      },
      immediate: true,
      deep: true,
    },
  },

  data() {
    return {
      innerAppts: null,
      amount: null,
      scheduledPaymentActionOptions: [
        {
          text: "No Payment Due",
          value: "NONE",
          price: 0,
          isSelected: false,
        },
        {
          text: "Deposit Due",
          value: "DEPOSIT",
          price: 0,
          isSelected: false,
        },
        {
          text: "Prepayment in Full",
          value: "FULL",
          price: 0,
          isSelected: false,
        },
      ],
      scheduledPaymentAction: "NONE",
      act: null,
    };
  },
  created() {
    this.setScheduledPaymentOptions();

    this.actionSelected(this.scheduledPaymentActionOptions[1]);

    var normalizedAppts = JSON.parse(JSON.stringify(this.appts));

    normalizedAppts.forEach((a) => {
      a.procedures.forEach((p) => {
        p.deposit = p.deposit / 100;
        p.price = p.price / 100;
      });
    });
    this.innerAppts = normalizedAppts;
  },
  methods: {
    setScheduledPaymentOptions() {
      this.scheduledPaymentActionOptions[0].price = 0;
      this.scheduledPaymentActionOptions[1].price = this.total.deposit;
      this.scheduledPaymentActionOptions[2].price = this.total.price;
    },
    buildAddApptRequest() {
      var req = [];

      //tighten up the request
      this.innerAppts.forEach((a) => {
        req.push({
          startDate: a.startDate,
          endDate: a.endDate,
          procedures: a.procedures.map((p) => {
            return {
              procedureId: p.id,
              minutes: p.minutes,
              deposit: Number.parseInt((p.deposit * 100).toFixed(0)),
              price: Number.parseInt((p.price * 100).toFixed(0)),
            };
          }),
          providerId: a.provider.providerId,
        });
      });

      return {
        appts: req,
        customerId: this.customer.id,
        scheduledPaymentAction: {
          value: this.act.value,
          price: (this.act.price * 100).toFixed(0),
        },
      };
    },
    async createAppt() {
      let r = await this.$client.post(
        "/api/appt/addAppt",
        this.buildAddApptRequest()
      );
      if (r.data.isSuccess) {
        this.$emitter.emit("success-confirm", {
          title: "Appointment Created",
          message:
            "Your appointment has been created, and the customer has been notified.",
          navigate: "/#/dashboard",
        });
      }
    },
    actionSelected(s) {
      this.scheduledPaymentActionOptions[0].isSelected = false;
      this.scheduledPaymentActionOptions[1].isSelected = false;
      this.scheduledPaymentActionOptions[2].isSelected = false;

      s.isSelected = true;

      this.amount = s.price * 100;
      this.act = s;
    },
  },
};
</script>

<style scoped>
.startPaymentWrapper {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 100px;
}
.wrapper {
  display: grid;
  grid-template-columns: 100px auto;
  column-gap: 75px;
}
</style>
